export default "__VITE_ASSET__Drv9ywq4__"